import { faMessageLines, faPlus, faQrcode } from '@fortawesome/pro-solid-svg-icons';

import { SmallActionButton } from '@/components/atoms';

export const SmallActionButtonsGroup = () => {
	return (
		<div className="flex flex-col gap-4 sm:flex-row">
			<div className="flex gap-4">
				<SmallActionButton prefixIcon={faPlus}>Add or move player</SmallActionButton>
				<SmallActionButton prefixIcon={faMessageLines}>Send text</SmallActionButton>
			</div>
			<div className="flex gap-4">
				<SmallActionButton>Invite with code</SmallActionButton>
				<SmallActionButton suffixIcon={faQrcode}>Invite with QR code</SmallActionButton>
			</div>
		</div>
	);
};
